import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { offerLinkApi } from "api/TenantSlug/OfferLink/api";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import GetOfferLinkRequest = App.Http.Requests.OfferLink.GetOfferLinkRequest;
import GetOfferLinksRequest = App.Http.Requests.OfferLink.GetOfferLinksRequest;
import StoreOfferLinkRequest = App.Http.Requests.OfferLink.StoreOfferLinkRequest;
import UpdateOfferLinkRequest = App.Http.Requests.OfferLink.UpdateOfferLinkRequest;
import GetOfferLinkResponse = App.Http.Responses.OfferLink.GetOfferLinkResponse;
import GetOfferLinksResponse = App.Http.Responses.OfferLink.GetOfferLinksResponse;

// Query to get a list of offer links
export const useGetOfferLinksQuery = (request: GetOfferLinksRequest, options = {}) => {
    return useQueryApi<GetOfferLinksResponse>({
        queryKey: ["getOfferLinks", request],
        queryFn: () => offerLinkApi.index(request),
        ...options,
    });
};

// Query to get a specific offer link by ID
export const useGetOfferLinkQuery = (offerLinkId: string, request?: GetOfferLinkRequest, options = {}) => {
    return useQueryApi<GetOfferLinkResponse>({
        queryKey: ["getOfferLink", offerLinkId],
        queryFn: () => offerLinkApi.show(offerLinkId, request),
        ...options,
    });
};

// Mutation to store a new offer link
export const useStoreOfferLinkMutation = (
    options: UseMutationOptions<GetOfferLinkResponse, AxiosError<ApiErrorResponse>, StoreOfferLinkRequest> = {}
) => {
    return useMutationApi<GetOfferLinkResponse, StoreOfferLinkRequest>({
        mutationKey: ["storeOfferLink"],
        mutationFn: (request) => offerLinkApi.store(request),
        ...options,
    });
};

// Mutation to update an existing offer link
export const useUpdateOfferLinkMutation = (options = {}) => {
    return useMutationApi<GetOfferLinkResponse, { offerLinkId: string; request: UpdateOfferLinkRequest }>({
        mutationKey: ["updateOfferLink"],
        mutationFn: ({ offerLinkId, request }) => offerLinkApi.update(offerLinkId, request),
        ...options,
    });
};

// Mutation to delete an offer link
export const useDestroyOfferLinkMutation = (
    options: UseMutationOptions<void, AxiosError<ApiErrorResponse>, { id: string }> = {}
) => {
    return useMutationApi<void, { id: string }>({
        mutationKey: ["destroyOfferLink"],
        mutationFn: ({ id }) => offerLinkApi.destroy(id),
        ...options,
    });
};
